/**
 * Learning Journey Service
 * API client for personalized learning system endpoints
 */
import apiClient from './apiClient';

export interface DimensionPosition {
    cefr: string;
    score: number;
    trend: 'IMPROVING' | 'STABLE' | 'DECLINING';
    dataPoints: number;
}

export interface JourneyPosition {
    overallCefr: string;
    overallScore: number;
    dimensions: Record<string, DimensionPosition>;
    confidence: number;
    dataPoints: number;
    lastUpdated: string;
}

export interface MemoryHealthItem {
    total: number;
    solid: number;
    needReview: number;
    fading: number;
    dueToday: number;
}

export interface MemoryHealth {
    total: number;
    solid: number;
    needReview: number;
    fading: number;
    dueToday: number;
    tomorrowProjection: { newFading: number };
    byType: {
        vocabulary: MemoryHealthItem;
        knowledgePoints: MemoryHealthItem;
        patterns: MemoryHealthItem;
    };
}

export interface DailyMenuItem {
    type: 'vocabulary' | 'knowledgePoint' | 'pattern';
    itemId: string;
    label: string;
    mode: string;
    retrievability?: number;
}

export interface DailyMenu {
    date: string;
    reviewItems: DailyMenuItem[];
    reviewCount: number;
    estimatedMinutes: number;
    focusDimension: string;
    focusReason: string;
    streakDay: number;
}

const learningJourneyService = {
    async getPosition(): Promise<JourneyPosition> {
        const { data } = await apiClient.get('/learning-journey/position');
        return data;
    },

    async getMemoryHealth(): Promise<MemoryHealth> {
        const { data } = await apiClient.get('/learning-journey/memory-health');
        return data;
    },

    async getDailyMenu(): Promise<DailyMenu> {
        const { data } = await apiClient.get('/learning-journey/daily-menu');
        return data;
    },
};

export default learningJourneyService;
